import { useState } from 'react';
import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { LoanGradeType, LoanGradeTypeOptions } from '@apply/constants';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { LoanStatusType } from '../../../../../../../../../../common/constants/LoanStatusType';
import { GradeReasonModal } from '../../../../../../../../../GradeReasonModal';

interface GradeFieldProps {
    /** Sub notes use the LOC grades; other loans use the rest. */
    isSubNote?: boolean;
}

/**
 * Changing the grade on a loan that's past Approved asks for a reason; cancelling that puts the saved grade back.
 */
export const GradeField = ({ isSubNote = false }: GradeFieldProps) => {
    const grade = useStandardLoanStore((state) => state.loan.grade);
    const statusId = useStandardLoanStore((state) => state.setupLoanContext.statusId);
    const savedGrade = useStandardLoanStore((state) => state.loanStepContext.savedGrade);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);
    const [isReasonOpen, set_isReasonOpen] = useState(false);

    const handleChange = (newGrade: LoanGradeType | undefined) => {
        if (statusId !== LoanStatusType.Approved && newGrade !== grade) {
            set_isReasonOpen(true);
        }
        updateLoan({ grade: newGrade });
    };

    return (
        <>
            <DropDownBox
                id='loanGrade'
                value={grade ?? null}
                onChange={(newGrade: LoanGradeType | null) => handleChange(newGrade ?? undefined)}
                label='Grade'
                // The blank row clears it, like the blank option in the old select
                dataSource={[
                    { id: null, name: '' },
                    ...LoanGradeTypeOptions.filter((option) => option.isLoc === isSubNote),
                ]}
                displayExpr='name'
                valueExpr='id'
                placeholder='Select'
                searchEnabled={false}
                width='100%'
                height='36px'
                layoutStyle={DropDownBoxLayoutStyle.Horizontal}
                labelWidth='150px'
            />
            <GradeReasonModal
                isOpen={isReasonOpen}
                defaultReason={undefined}
                onSubmit={(reason: string) => {
                    updateLoan({ gradeReason: reason });
                    set_isReasonOpen(false);
                }}
                onCancel={() => {
                    updateLoan({ grade: savedGrade });
                    set_isReasonOpen(false);
                }}
            />
        </>
    );
};
